export const MOCK_CONFIG = {
    bentleyIdEnabled: false,
    bentleyIdEnabledCentral: false,
    blocksync_segmentWriteKey: 'testwritekey',
    central_segmentWriteKey: 'testwritekey',
    discovery_url: 'https://mock-discover.api.seequent.com',
    imago_segmentWriteKey: 'testwritekey',
    evo_segmentWriteKey: 'testwritekey',
    applicationInsightsConnection: 'testAppInsightsConnection',
    entitlements_url: 'https://ent-api.com',
    identity_url: 'https://id-api.com',
    environment: 'development',
    launchDarklyClientID: '123456',
    manageApi: 'https://manage.com',
    notificationsUrl: 'https://uat1.notifications.seequent.systems',
    publicStorageUrl: 'https://publicscenestest.dev.central.seequent.com/blobs',
    openStreetMapUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    publicSentryDsn: 'testsentrydsn',
    xid_base_url: 'https://xid-dev.geosoft.com',
    bentleyBaseUrl: 'https://qa-ims.bentley.com',
    bentleyUserManagementUrl: 'https://qa-usermanagement.bentley.com',
};
export const MOCK_DEV_SLOT_CONFIG = {
    bentleyIdEnabled: false,
    bentleyIdEnabledCentral: false,
    blocksync_segmentWriteKey: 'testwritekey',
    central_segmentWriteKey: 'testwritekey',
    discovery_url: 'https://mock-discover.api.seequent.com',
    imago_segmentWriteKey: 'testwritekey',
    evo_segmentWriteKey: 'testwritekey',
    applicationInsightsConnection: 'testAppInsightsConnection',
    entitlements_url: 'https://ent-api.com',
    identity_url: 'https://id-api.com',
    environment: 'development',
    launchDarklyClientID: '123456',
    manageApi: 'https://manage.com',
    notificationsUrl: 'https://uat1.notifications.seequent.systems',
    publicStorageUrl: 'https://publicscenestest.dev.central.seequent.com/blobs',
    openStreetMapUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    publicSentryDsn: 'testsentrydsn',
    xid_base_url: 'https://xid-dev.geosoft.com',
    bentleyBaseUrl: 'https://qa-ims.bentley.com',
    bentleyUserManagementUrl: 'https://qa-usermanagement.bentley.com',
};
export const MOCK_DEV_SLOT_CONFIG_OVERRIDES = {
    segmentWriteKey: 'testwritekeyoverride',
    environment: 'development',
    launchDarklyClientID: '987654',
    xid_base_url: 'https://xid-dev.geosoft.override.com',
};
export const MOCK_DEV_CONFIG_OVERRIDDEN = Object.assign(Object.assign({}, MOCK_DEV_SLOT_CONFIG), MOCK_DEV_SLOT_CONFIG_OVERRIDES);
export const MOCK_DEV_BENTLEY_CONFIG = Object.assign(Object.assign({}, MOCK_CONFIG), { bentleyIdEnabled: true });
//# sourceMappingURL=mockConfig.js.map